import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationComponent } from './components/notification/notification.component';
import { ButtonLegacyModule } from '../button-legacy/button-legacy.module';
import { IconModule } from '../icon/icon.module';

@NgModule({
  declarations: [NotificationComponent],
  imports: [CommonModule, IconModule, ButtonLegacyModule],
  exports: [NotificationComponent],
})
export class NotificationModule {}
